import todo from "./images/icon-todo.svg";
import calender from "./images/icon-calendar.svg";
import reminder from "./images/icon-reminders.svg";
import planning from "./images/icon-planning.svg";
const SubFeatures = ({ subFeatures }) => {
  const style = {
    display: subFeatures ? "block" : "none",
  };
  return (
    <div className="forHide">
      <ul style={style} className="list block1">
        <li>
          <img src={todo} alt="todo list" />
          todo list
        </li>
        <li>
          <img src={calender} alt="calender" />
          calendar
        </li>
        <li>
          <img src={reminder} alt="reminder" />
          reminder
        </li>
        <li>
          <img src={planning} alt="planning" />
          planning
        </li>
      </ul>
    </div>
  );
};
export default SubFeatures;
